import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
// import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { getQuoteState } from "@MasterBluePrint/Store/Data/Quotes/QuotesSelector";
// import { RfqQuoteDetailsPageContext } from "@insite/content-library/Pages/RfqQuoteDetailsPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import{RfqQuoteDetailPageContext} from "@MasterBluePrint/Pages/RfqQuoteDetailPage";
import themeColors, { themeFontSizes, themeFontWeights, themeIndentSizes } from "@MasterBluePrint/Styles/variables";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});


type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface RfqQuoteDetailSubtotalStyles {
    quoteContainer?: InjectableCss;
    container?: GridContainerProps;
    subtotalLabelGridItem?: GridItemProps;
    subtotalLabel?: TypographyProps;
    subtotalValueGridItem?: GridItemProps;
    subtotalValue?: TypographyProps;
    discountsLabelGridItem?: GridItemProps;
    discountsLabel?: TypographyProps;
    discountsValueGridItem?: GridItemProps;
    discountsValue?: TypographyProps;
    shippingAndHandlingLabelGridItem?: GridItemProps;
    shippingAndHandlingLabel?: TypographyProps;
    shippingAndHandlingLabelNew?: TypographyProps;
    shippingAndHandlingValueGridItem?: GridItemProps;
    shippingAndHandlingValue?: TypographyProps;
    otherChargesLabelGridItem?: GridItemProps;
    otherChargesLabel?: TypographyProps;
    otherChargesValueGridItem?: GridItemProps;
    otherChargesValue?: TypographyProps;
    taxLabelGridItem?: GridItemProps;
    taxLabel?: TypographyProps;
    taxValueGridItem?: GridItemProps;
    taxValue?: TypographyProps;
    totalLabelGridItem?: GridItemProps;
    totalLabel?: TypographyProps;
    totalValueGridItem?: GridItemProps;
    totalValue?: TypographyProps;
    sideWrapper?: InjectableCss;
}

export const rfqQuoteDetailSubtotalStyles: RfqQuoteDetailSubtotalStyles = {
    quoteContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        .desktop-subtotal-wrapper {
                            display: none;
                        }
                        .mobile-subtotal-wrapper {
                            display: block;
                        }
                    `,
                ],
                "max",
            )} 
            
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    null,
                    css`
                        .desktop-subtotal-wrapper {
                            display: block;
                        }
                        .mobile-subtotal-wrapper {
                            display: none;
                        }
                    `,
                ],
                "min",
            )}

        `,
    },
    container: {
        gap: 10,
        css: css`
            background: ${getColor("common.accent")};
            padding: 1.25rem 0;
            .border-seperator {
                border-bottom: 1px solid ${themeColors.colorLightPureBlue};
                padding-top: 0.9375rem;
                margin: 0 0.3125rem 0.9375rem 0.3125rem;
                width: 100%;
                display: block;
            }
            > div {
                div:nth-child(odd) {
                    > span {
                        color: ${themeColors.colorCharcoalGrey};
                        font-family: Roboto, sans-serif;
                        font-size: ${themeFontSizes.size16};
                        font-weight: ${themeFontWeights.fontWeightMedium};
                        letter-spacing: -0.31px;
                        line-height: ${themeIndentSizes.indent23};
                        &.total-value {
                            color: ${themeColors.colorRed};
                            font-family: Roboto;
                            font-size: ${themeFontSizes.size22};
                            font-weight: ${themeFontWeights.fontWeightForBold};
                            letter-spacing: -0.42px;
                            line-height: ${themeIndentSizes.indent23};
                            text-align: right;
                        }
                    }
                    > span.subtotal-value {
                        font-weight: bold;
                        color: ${themeColors.colorCharcoalGrey};
                    }
                    .total-label {
                        color: ${themeColors.colorCharcoalGrey};
                        font-family: Roboto, sans-serif;
                        font-size: ${themeFontSizes.size20};
                        font-weight: ${themeFontWeights.fontWeightMedium};
                        letter-spacing: -0.38px;
                        line-height: ${themeIndentSizes.indent23};
                        text-align: left !important;
                    }
                }
                div:nth-child(even) {
                    text-align: right;
                    > span {
                        color: ${themeColors.colorCharcoalGrey};
                        font-family: Roboto;
                        font-size: ${themeFontSizes.size20};
                        letter-spacing: -0.38px;
                        line-height: ${themeIndentSizes.indent23};
                    }
                    > span.subtotal-value {
                        font-weight: ${themeFontWeights.fontWeightForBold};
                    }
                }
            }
        `,
    },
    subtotalLabelGridItem: {
        width: 6
    },
    subtotalValueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 6,
    },
    subtotalValue: {
        css: css`
            margin-left: auto;
        `,
    },
    discountsLabelGridItem: { width: 6 },
    discountsValueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 6,
    },
    discountsValue: {
        css: css`
            margin-left: auto;
        `,
    },
    shippingAndHandlingLabelGridItem: { width: 6 },
    shippingAndHandlingValueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 6,
    },
    sideWrapper: {
        css: css`
            span.quote-items {
                border-bottom: 1px solid #C2D1D9;
                color: ${themeColors.colorCharcoalGrey};
                font-family: 'Lato',sans-serif;
                font-size: .9375rem;
                font-weight: ${themeFontWeights.fontWeightForBold};
                letter-spacing: 0.17px;
                line-height: 1.125rem;
                padding-bottom: 1rem;
                display: block;

                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            margin-bottom: .9375rem;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
    shippingAndHandlingLabelNew: {
        css: css`
            position: relative;
            font-size: 1rem;
            font-weight: ${themeFontWeights.fontWeightMedium};
            -webkit-letter-spacing: -0.31px;
            -moz-letter-spacing: -0.31px;
            -ms-letter-spacing: -0.31px;
            letter-spacing: -0.31px;
            line-height: 1.4375rem;
            width: 100%;
            text-align: right;
            justify-content: right;
            display: flex;
        `,
    },
    shippingAndHandlingValue: {
        css: css`
            margin-left: auto;
        `,
    },
    otherChargesLabelGridItem: { width: 6 },
    otherChargesValueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 6,
    },
    otherChargesValue: {
        css: css`
            margin-left: auto;
        `,
    },
    taxLabelGridItem: { width: 6 },
    taxValueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 6,
    },
    taxValue: {
        css: css`
            margin-left: auto;
        `,
    },
    totalLabelGridItem: { width: 6 },
    totalLabel: { weight: "bold" },
    totalValueGridItem: {
        css: css`
            @media print {
                text-align: right;
            }
        `,
        width: 6,
    },
    totalValue: {
        weight: "bold",
        css: css`
            margin-left: auto;
        `,
    },

};

const styles = rfqQuoteDetailSubtotalStyles;

const RfqQuoteDetailSubtotal = ({
    quoteState,
}: Props) => {
    const quote = quoteState.value;
    if (!quote) {
        return null;
    }
    return (
        <Typography as="div" className="quote-subtotal-container" {...styles.quoteContainer}>
            {quote.cartLines && quote.cartLines?.length > 3 && (
                <Typography as="div" {...styles.sideWrapper} data-test-selector="quoteSubtotalWrapper" className="desktop-subtotal-wrapper">
                    <GridContainer {...styles.container}>
                        <GridItem {...styles.subtotalLabelGridItem}>
                            <Typography {...styles.subtotalLabel}>
                                {translate("Subtotal")}
                            </Typography>
                        </GridItem>
                        <GridItem {...styles.subtotalValueGridItem}>
                            <Typography {...styles.subtotalValue} className="subtotal-value">{quote.orderSubTotalDisplay}</Typography>
                        </GridItem>
                        {quote.orderSubTotalWithOutProductDiscounts > 0 && (
                            <>
                                <GridItem {...styles.discountsLabelGridItem}>
                                    <Typography {...styles.discountsLabel}>{translate("Discounts")}</Typography>
                                </GridItem>
                                <GridItem {...styles.discountsValueGridItem}>
                                    <Typography {...styles.discountsValue}>{`-${quote.orderSubTotalWithOutProductDiscountsDisplay}`}</Typography>
                                </GridItem>
                            </>
                        )}
                        {quote.showTaxAndShipping && quote.shippingAndHandlingDisplay.length > 0 && (
                            <>
                                <GridItem {...styles.shippingAndHandlingLabelGridItem}>
                                    <Typography {...styles.shippingAndHandlingLabel}>{translate("Shipping & Handling")}</Typography>
                                </GridItem>
                                <GridItem {...styles.shippingAndHandlingValueGridItem}>
                                    <Typography {...styles.shippingAndHandlingValue}>

                                        {quote.shippingAndHandling === 0 ? (

                                            <Typography {...styles.shippingAndHandlingLabelNew}>
                                                {translate("ShippingandHandlingYetToBeCalculated")}
                                            </Typography>
                                        ) :
                                            quote.shippingAndHandlingDisplay}
                                    </Typography>
                                </GridItem>
                            </>
                        )}
                        {(!quote.customerOrderTaxes || quote.customerOrderTaxes.length === 0) && (
                            <>
                                <GridItem {...styles.taxLabelGridItem}>
                                    <Typography {...styles.taxLabel}>{translate("Tax")}</Typography>
                                </GridItem>
                                <GridItem {...styles.taxValueGridItem}>
                                    <Typography {...styles.taxValue} data-test-selector="orderDetails_totalTaxDisplay">
                                        {quote.totalTaxDisplay}
                                    </Typography>
                                </GridItem>
                            </>
                        )}

                        <Typography as="span" className="border-seperator"></Typography>
                        <GridItem {...styles.totalLabelGridItem}>
                            <Typography {...styles.totalLabel} className="total-label">{translate("Total")}</Typography>
                        </GridItem>
                        <GridItem {...styles.totalValueGridItem}>
                            <Typography {...styles.totalValue} className="total-value" data-test-selector="orderDetail_orderGrandTotalDisplay">
                                {quote.orderGrandTotalDisplay}
                            </Typography>
                        </GridItem>
                    </GridContainer>
                </Typography>
            )}
        </Typography>

    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(RfqQuoteDetailSubtotal),
    definition: {
        displayName: "Quote Detail Subtotal",
        fieldDefinitions: [],
        group: "RFQ Quote Details",
    },
};

export default widgetModule;
